// UserDetails.js
import axios from "axios";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";

const UserDetails = () => {
  const [UserDetails, SetUserDetails] = useState([]);

  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const fetchUserDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/user/FetchUserList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );

      // const response = await axios.get(`http://localhost:8080/admin/realms/myrealm/users`,{ headers: {
      //   Authorization: `Bearer ${sessionStorage.getItem('access_token')}`
      // },withCredentials: true});
      // console.log(response)
      SetUserDetails(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);
  return (
    <div className="centered-component">
      <ToastContainer />
      <h2 className="UserManagementDetailsHeadLabel">User Details</h2>
      <table className="UserDetailsTable">
        <tr className="UserDetailsTableRow">
          <th>Username</th>
          <th>Status</th>
        </tr>
        {UserDetails.length < 1 ? (
          <tr style={{ backgroundColor: "white" }}>No Details Found</tr>
        ) : (
          UserDetails.map((items, index) => {
            return (
              <tr key={index} className="UserDetailsTableRow">
                <td>{items.Username}</td>
                <td>{items.Active_Status}</td>
              </tr>
            );
          })
        )}
      </table>
    </div>
  );
};

export default UserDetails;
